<template>
  <section class="gap-table">
    <div class="gap-table__inactive gap-table__inactive--previous">
      <gap-header type="previous" />
      <slot name="previous" />
    </div>

    <div class="gap-table__active">
      <gap-header type="active" />
      <slot name="active" />
    </div>

    <div class="gap-table__inactive gap-table__inactive--next">
      <gap-header type="next" />
      <slot name="next" />
    </div>
  </section>
</template>

<script>
import gapHeader from './gapHeader.vue'

export default {
  name: 'CGapTable',

  components: {
    gapHeader
  }
}
</script>

<style lang="scss">
@import "../css/variables";

.gap-table {
  @media (min-width: $breakpoint-md) {
    display: flex;
    justify-content: space-between;
    flex-grow: 1;
  }
}

.gap-table__active {
  flex-grow: 1;
}

.gap-table__inactive {
  display: none;
  flex-shrink: 0;
  width: 14rem;

  opacity: 0.5;

  pointer-events: none;
}

.gap-table__inactive--previous {
  margin-right: $gutter-xs;

  @media (min-width: $breakpoint-xxl) {
    display: block;
  }
}

.gap-table__inactive--next {
  margin-left: $gutter-xs;

  @media (min-width: $breakpoint-xl) {
    display: block;
  }
}
</style>
